import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, PropType } from "vue";
import {
  BCollapse,
  BDropdownItem,
  BIconBell,
  BIconBuilding,
  BIconBullseye,
  BIconCode,
  BIconEnvelope,
  BIconHouse,
  BIconNewspaper,
  BIconQuestionCircle,
  BNavbar,
  BNavbarToggle,
  BNavItemDropdown,
} from "bootstrap-vue";
import Github from "@/components/organization/logo/github.vue";
import Search from "@/components/search.vue";
import useStore from "@/store/useStore";
import { useRoute, useRouter } from "vue-router/composables";

export interface BrandLogo {
  src: string;
  alt: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  props: {
  faqRoute: {
    type: String,
    required: false,
  },
  brandName: {
    type: String,
    required: true,
  },
  brandTagline: {
    type: String,
    required: true,
  },
  includeOrganizations: {
    type: Boolean,
    default: true,
  },
  includeNotify: {
    type: Boolean,
    default: false,
  },
  includeFAQ: {
    type: Boolean,
    default: false,
  },
  apiDocUrl: {
    type: String,
  },
  blogUrl: {
    type: String,
  },
  githubUrl: {
    type: String,
  },
  mailTo: {
    type: String,
  },
  brandLogo: {
    type: Object as PropType<BrandLogo>,
  },
},
  setup(__props) {

const props = __props;



const store = useStore();
const route = useRoute();
const router = useRouter();

const brandLogoSource = ref(
  props.brandLogo?.src ? require(`@/assets/logo.svg`) : ""
); //require needs to happen before mount
const navigateToNetwork = (networkId: string) => {
  if (networkId === store.networkContext.networkId) return;
  router
    .push({
      name: "network-dashboard",
      query: { network: networkId },
    })
    .catch(() => {
      //this triggers a navigation guard error that we can safely ignore. See router beforeEach
    });
};

const homeActiveClass = computed(() => {
  return {
    active:
      route.name === "network-dashboard" ||
      route.name === "node-dashboard" ||
      route.name === "organization-dashboard",
  };
});

return { __sfc: true,props, store, route, router, brandLogoSource, navigateToNetwork, homeActiveClass, BCollapse, BDropdownItem, BIconBell, BIconBuilding, BIconBullseye, BIconCode, BIconEnvelope, BIconHouse, BIconNewspaper, BIconQuestionCircle, BNavbar, BNavbarToggle, BNavItemDropdown, Github, Search }
}

})